import axios from 'axios';
import dayjs from 'dayjs';

export default {
  state: {
    applications: [],
    loading: false,
    total: 0,
    refresh: false,
    selectedApplication: {},
    filter: {
      from: dayjs().startOf('year').format("YYYY-MM-DD"),
      to: dayjs().endOf('year').format("YYYY-MM-DD")
    }
  },
  getters: {
    applications: (state) => {
      return state.applications;
    },
  },
  mutations: {
    SET_APPLICATIONS(state, applications) {
      state.applications = applications;
    },
    SET_TOTAL(state, total) {
      state.total = total;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
    SET_REFRESH(state, val) {
      state.refresh = val;
    },
    SET_FILTERS(state, val) {
      state.filter = val
    }
  },
  actions: {
    getNetworkJoinApplications({ commit, state }, params) {
      commit('SET_LOADING', true);
      axios.get('api/network-join/applications', {
        params: {
          ...params,
          ...state.filter
        }
      }).then(response => {
        commit('SET_APPLICATIONS', response.data.applications);
        commit('SET_TOTAL', response.data.total);
        commit('SET_LOADING', false);
      }, () => {
        commit('SET_LOADING', false);
      })
    },
    // eslint-disable-next-line
    saveNetworkJoinApplication({ }, data) {
      return new Promise((resolve, reject) => {
        axios({ url: '/api/network-join/add', data, method: 'POST' })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // eslint-disable-next-line
    updateNetworkJoinApplication({ }, data) {
      return new Promise((resolve, reject) => {
        axios({ url: '/api/network-join/update', data, method: 'POST' })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setRefresh({ commit }, value) {
      commit('SET_REFRESH', value)
    },
    // eslint-disable-next-line
    deleteNetworkJoinApplication({ }, data) {
      return new Promise((resolve, reject) => {
        axios({ url: '/api/network-join/delete', data, method: 'POST' })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setApplicationsFilter({ commit }, filter) {
      commit("SET_FILTERS", filter)
    },
    exportNetworkJoinApplications({ state }, params) {
      return new Promise((resolve, reject) => {
        axios.get('api/network-join/export', {
          params: {
            ...params,
            ...state.filter
          }
        })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  }
}